import config from '../lib/config'

export function loadStyles() {
  return new Promise((resolve, reject) => {
    const stylesheet = document.createElement('link')
    stylesheet.id = 'nginBarCss'
    stylesheet.rel = 'stylesheet'
    stylesheet.href = `${config.urls.snapTheme}/main-v2.css?20190108`
    document.head.appendChild(stylesheet)
    stylesheet.addEventListener('load', () => resolve())
    stylesheet.addEventListener('error', (err) => reject(err))
  })
}

export function loadSpriteSheet() {
  return fetch(config.urls.svg)
    .then((response) => {
      if (!response.ok) throw new Error(`Request failed with status code ${response.status}`)
      return response.text()
    })
    .then((spriteSheet) => {
      const spritesheet = document.createElement('span')
      spritesheet.innerHTML = spriteSheet
      document.body.appendChild(spritesheet)
    })
}

export function loadAllResources() {
  return Promise.all([
    loadSpriteSheet(),
    loadStyles(),
  ])
}
